import { gql } from "@apollo/client";

export const GET_NAMED_WEBHOOK = gql`
  query GetNamedWebhook($id: ID!, $nextToken: String) {
    namedWebhooksIntegration(id: $id) {
      id
      space {
        id
        name
        accessLevel
      }
      deliveries(token: $nextToken) {
        nodes {
          id
          status
          timestamp
        }
        nextToken
      }
      plugin {
        id
        name
      }
      enabled
      retryOnFailure
      endpoint
      name
      labels
      secretHeaders
      createdAt
    }
  }
`;
